import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=9ea4ded8&scoped=true"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"
import style0 from "./BaseCarousel.vue?vue&type=style&index=0&id=9ea4ded8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea4ded8",
  null
  
)

export default component.exports